import { render, staticRenderFns } from "./DashboardView.vue?vue&type=template&id=31ed863a&scoped=true&"
import script from "./DashboardView.vue?vue&type=script&lang=js&"
export * from "./DashboardView.vue?vue&type=script&lang=js&"
import style0 from "../../../public/assets/css/farmerspage.css?vue&type=style&index=0&id=31ed863a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ed863a",
  null
  
)

export default component.exports